/**
 * SVG icon components for markup tools
 * Feature: 049-critique-photo-markup
 */

interface IconProps {
  className?: string;
}

/**
 * Pointer/cursor icon (default selection tool)
 */
export function PointerIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="Pointer tool"
    >
      <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" />
      <path d="M13 13l6 6" />
    </svg>
  );
}

/**
 * Circle icon
 */
export function CircleIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="Circle tool"
    >
      <circle cx="12" cy="12" r="9" />
    </svg>
  );
}

/**
 * Rectangle icon
 */
export function RectangleIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="Rectangle tool"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
    </svg>
  );
}

/**
 * Arrow icon
 */
export function ArrowIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="Arrow tool"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

/**
 * Spotlight icon - rectangle with dimming effect
 */
export function SpotlightIcon({ className = 'w-5 h-5' }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="Spotlight tool"
    >
      {/* Outer dimmed area */}
      <rect x="2" y="2" width="20" height="20" fill="currentColor" opacity="0.15" stroke="none" />
      {/* Highlighted/spotlight rectangle */}
      <rect x="7" y="7" width="10" height="10" rx="1" />
    </svg>
  );
}
